// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-index-jsx" + "-" + "fdc4195ac66ee2b40459" + ".js";
};